// Rendering geometry shared by the comparison viewer and the shareable card.
//
// EXPORT SAFETY — READ BEFORE EDITING:
// html2canvas@1.4.1 implements NONE of `object-fit`, `object-position`,
// `clip-path` or `filter` (0 occurrences of each in its dist bundle). Anything
// in the SHARE CARD subtree that uses them exports wrong, silently. That is why
// `explicitPhotoGeometry` exists: it is `object-fit: cover` + `object-position`
// done in arithmetic, using only properties html2canvas can rasterise.
//
// The viewer is exempt — it renders in a real browser and keeps using object-fit.

// Compose auto-alignment + manual nudge into a single CSS transform string.
// Both arguments are in normalized units (translate as a fraction of the frame,
// rotate in degrees).
export function transformString(align, manual) {
  const a = align || { scale: 1, translateX: 0, translateY: 0, rotate: 0 };
  const m = manual || { scale: 1, translateX: 0, translateY: 0, rotate: 0 };
  const tx = (a.translateX + m.translateX) * 100;
  const ty = (a.translateY + m.translateY) * 100;
  const s = a.scale * m.scale;
  const r = a.rotate + m.rotate;
  return `translate(${tx}%, ${ty}%) rotate(${r}deg) scale(${s})`;
}

// The aperture is the box the alignment was solved for: ALWAYS 9:16.
// It is sized from the slot's HEIGHT only, so it can never be cropped
// vertically — vertical crop would take the head (anchored at 6% from the top)
// or the feet. Horizontal excess is clipped by the slot; horizontal shortfall
// is filled by a pre-blurred backdrop.
export function apertureSize(slotW, slotH, ratio = 9 / 16) {
  const height = slotH;
  const width = slotH * ratio;
  return { width, height, letterboxed: width < slotW };
}

// Arithmetic equivalent of `object-fit: cover; object-position: cxPct% cyPct%`
// for a natural image inside a box. Returns absolute pixel geometry for the
// <img> element.
export function explicitPhotoGeometry({ natural, boxW, boxH, cxPct, cyPct }) {
  const nw = natural && natural.w > 0 ? natural.w : 1;
  const nh = natural && natural.h > 0 ? natural.h : 1;
  const coverScale = Math.max(boxW / nw, boxH / nh);
  const width = nw * coverScale;
  const height = nh * coverScale;
  return {
    width,
    height,
    left: (boxW - width) * (cxPct / 100),
    top: (boxH - height) * (cyPct / 100),
  };
}
